import styled from 'styled-components';

const SkeletonLoaderWrapper = styled.div`
  background: #fff;
  border: 1px solid #d9dde9;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  min-height: 156px;
  padding: 24px;
`;

const SkeletonLoader = styled.div`
  height: 16px;
  width: 100%;
  margin-top: 16px;
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    ),
    rgba(238, 238, 238);
  background-repeat: repeat-y;
  background-size: 100px 100px;
  background-position: 0 0;
  animation: shine 1s infinite;

  @keyframes shine {
    to {
      background-position: 100% 0, 0 0;
    }
  }
`;

const SkeletonLoaderLineFull = styled(SkeletonLoader)`
  width: 100%;
`;

const SkeletonLoaderLineHalf = styled(SkeletonLoader)`
  width: 50%;
`;

const SkeletonLoaderLineQuarter = styled(SkeletonLoader)`
  width: 50%;
`;

export {
  SkeletonLoaderWrapper,
  SkeletonLoaderLineFull,
  SkeletonLoaderLineHalf,
  SkeletonLoaderLineQuarter,
};
